import { Component, ElementRef, Input, OnInit, Optional, Renderer } from '@angular/core';
import { BaseInput } from 'ionic-angular/util/base-input';
import { Config, Form, Item } from 'ionic-angular';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CorsHttpProvider } from '../../providers/http/http';
import { URLParamsBuilder } from '../../utils/http/url-params-builder';


export class LazySelect extends BaseInput<any> implements OnInit {

  options: Array<any> = [];

  
  placeholder: string;

  
  chooseTextField: boolean = false;

  
  chooseText: string = '请选择';

  
  url: string;

  
  params: any;

  
  valueField: string = 'id';

  
  textField: string = 'name';

  
  disabled: boolean = false;

  constructor(
    config: Config,
    elementRef: ElementRef,
    renderer: Renderer,
    form: Form,
     item: Item,
    private http: CorsHttpProvider
  ) {
    super(config, elementRef, renderer, 'ion-lazy-select', '', form, item, null);
  }

  ngOnInit(): void {
    this.http.request<Array<any>>(
      this.url,
      { cache: true, cacheOnly: true, memCache: true, search: URLParamsBuilder.build(this.params), showLoading: false }
    ).then((data: Array<any>) => {
      this.options = data;
    }).catch(e => {
      Promise.reject(e);
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ion-lazy-select',
  styles: [`
    ion-select {
      max-width: 100%;
    }
  `],
  template: `
    <ion-select [(ngModel)]="value" interface="popover" [placeholder]="placeholder" [disabled]="disabled">
      <ion-option value="" *ngIf="chooseTextField">{{chooseText}}</ion-option>
      <ion-option value="{{option[valueField]}}" *ngFor="let option of options">{{option[textField]}}</ion-option>
    </ion-select>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: LazySelect,
    multi: true
  }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Config, },
{type: ElementRef, },
{type: Renderer, },
{type: Form, },
{type: Item, decorators: [{ type: Optional }, ]},
{type: CorsHttpProvider, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'placeholder': [{ type: Input },],
'chooseTextField': [{ type: Input },],
'chooseText': [{ type: Input },],
'url': [{ type: Input },],
'params': [{ type: Input },],
'valueField': [{ type: Input },],
'textField': [{ type: Input },],
'disabled': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
